<div class="widget-bg-color px-5 content-center justify-end h-full rounded-xl">
  <sp-loading-inprogress *ngIf="loading; else loadingComplete" [diameter]="50" [showSpinner]="true"></sp-loading-inprogress>
  <ng-template #loadingComplete>
    <ng-template [ngIf]="collectionList && collectionList.length > 0">
      <sp-custom-generic-table
        [tableCols]="columns"
        [tableData]="collectionList"
        tableType="assets"
        [actionColumn]="true"
        [expandActionColumn]="groupedViewFlag"
        [configObject]="configObject"
        (clickSortFilter)="onClickSortFilter($event)"
        [itemSize]="itemSize"
        (checkboxChanged)="onSelectCollection($event._id)"
      >
        <ng-template let-collectionID let-i #rowActionMenu>
          <thehubz-collection-action-menu
            [collectionIndex]="i"
            [collection]="getCollection(collectionID)"
            (deleteCollection)="onDeleteCollection(collectionID)"
            (downloadCollection)="onDownloadCollection(collectionID)"
            (editCollection)="onEditCollection(collectionID)"
            (shareCollection)="onShareCollection(collectionID)"
            (publishCollection)="onPublishCollection(collectionID)"
            (unpublishCollection)="onUnpublishCollection(collectionID)"
          >
          </thehubz-collection-action-menu>
        </ng-template>
      </sp-custom-generic-table>
    </ng-template>
  </ng-template>
</div>
